module.exports = __webpack_public_path__ + "img/album14_08.c0a666e3.jpg";